import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import LoadingAnimation from "../../components/animation/LoadingAnimation";
import FloatingChatButton from "../../components/button/FloatingChatButton";
import OrderInfoDialogBox from "../../components/dialogBox/OrderInfoDialogBox";
import Footer from "../../components/footer/Footer";
import Navbar from "../../components/navbar/Navbar";
import OrderSummaryCard from "../../components/order/OrderSummaryCard";
import ProductCartCard from "../../components/product/ProductCartCard";
import H2 from "../../components/typography/H2";
import { cartService } from "../../service/CartService";
import colors from "../../theme/color/ColorTheme";

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  margin: 0px 5%;
  h2 {
    text-align: center;
  }
`;

const Space = styled.div`
  height: 20px;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  gap: 50px;
  flex: 1;
  position: relative;

  @media (max-width: 950px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const CartItems = styled.div`
  flex: 1;
`;

const Line = styled.div`
  height: 1px;
  background-color: ${colors.border};
  width: 100%;
`;

const CheckoutDetails = styled.div`
  /* flex-shrink: 0; */
  display: flex;
  flex-direction: column;
  gap: 40px;
  position: sticky;
  top: 180px;
  height: fit-content;
  max-height: calc(100vh - 200px);
  overflow-y: auto;

  @media (max-width: 950px) {
    position: relative;
    top: 0;
    max-height: none;
    width: fit-content;
    margin: auto;
  }
`;

function CartPage() {
  const [cart, setCart] = useState();
  const [triggerRebuild, setTriggerRebuild] = useState();
  const [loading, setLoading] = useState();
  const [shippingFee, setShippingFee] = useState(0);

  useEffect(() => {
    const fetchCart = async () => {
      setLoading(true);
      const cart = await cartService.getCart();
      cart && setCart(cart);
      setTriggerRebuild(false);
      setLoading(false);
    };

    fetchCart();
  }, [triggerRebuild]);

  const navigate = useNavigate();
  return (
    <Wrapper>
      <FloatingChatButton />
      <Navbar />
      <Space />
      <Space />
      <Container>
        <H2>Shopping Cart</H2>
        <Space />
        <Space />
        <Flex>
          <CartItems>
            {loading ? (
              <LoadingAnimation />
            ) : (
              cart &&
              cart.map((cartItem, key) => (
                <>
                  <ProductCartCard
                    cart={cartItem}
                    key={key}
                    triggerRebuildParent={setTriggerRebuild}
                  />
                  <Space />
                  <Line />
                  <Space />
                </>
              ))
            )}
          </CartItems>

          <CheckoutDetails>
            {cart && (
              <OrderSummaryCard
                actionText={"Continue to checkout"}
                actionOnClick={() => {
                  navigate("/order");
                }}
                cart={cart}
                shippingFee={shippingFee}
              />
            )}

            <OrderInfoDialogBox />
          </CheckoutDetails>
        </Flex>
      </Container>
      <Space />
      <Space />
      <Footer />
    </Wrapper>
  );
}

export default CartPage;
